import { SearchStateProp } from 'types/shopConfig'

export const DEFAULT_FILTERS_LIST = [
  'stockStatusReason:product.stockStatus.available',
  'stockStatusReason:product.stockStatus.nl'
]
export const SEARCHABLE_FILTERS_LIST = [
  ...DEFAULT_FILTERS_LIST,
  'stockStatusReason:product.stockStatus.notInCatalog',
  'stockStatusReason:product.stockStatus.av',
  'stockStatusReason:product.stockStatus.gratis'
]

export const DEFAULT_FILTERS = '(%statusIn)'.replace(
  '%statusIn',
  DEFAULT_FILTERS_LIST.join(' OR ')
)

export const SEARCHABLE_FILTERS = SEARCHABLE_FILTERS_LIST.join(' OR ')

export const DEFAULT_PARAMS = {
  analytics: false,
  analyticsTags: [],
  clickAnalytics: false,
  filters: DEFAULT_FILTERS
}

export const EMPTY_RESPONSE = {
  hits: [],
  nbHits: 0,
  processingTimeMS: 0
}

export const ANALYTICS_TAG_RESULTS = 'results'
export const ANALYTICS_TAG_SUGGESTIONS = 'suggestions'

export const SEARCH_TYPE = 'searchType'

export const HITS_PER_PAGE_SEARCH_BOX = 5
export const HITS_PER_PAGE_PRODUCT_FILTER = 30

export const RELEVANCY_DESC_KEY = 'relevancy_desc'
export const TOP_SELLER_COUNT_DESC_KEY = 'topsellerCount_desc'
export const PRICE_ASC_KEY = 'price_asc'
export const PRICE_DESC_KEY = 'price_desc'
export const PRODUCT_NAME_ASC_KEY = 'productName_asc'
export const PRODUCT_NAME_DESC_KEY = 'productName_desc'

export const SORTING_KEYS = [
  RELEVANCY_DESC_KEY,
  TOP_SELLER_COUNT_DESC_KEY,
  PRICE_ASC_KEY,
  PRICE_DESC_KEY,
  PRODUCT_NAME_ASC_KEY,
  PRODUCT_NAME_DESC_KEY
]

export const CATEGORY_LEAF_SORTING_KEYS = [
  TOP_SELLER_COUNT_DESC_KEY,
  PRICE_ASC_KEY,
  PRICE_DESC_KEY,
  PRODUCT_NAME_ASC_KEY,
  PRODUCT_NAME_DESC_KEY
]

export const DISJUNCTIVE_FACETS = [
  'pharmaForm',
  'variants.packSize',
  'price',
  'averageRating',
  'brandIntern',
  'nowProductGroup',
  'filterAttributes',
  'primaryCategory',
  'activeSubstances',
  'prescriptionMedicine',
  'manufacturer',
  'potency'
] as const

export const SEARCH_STATE_PROPS_WHITELIST = [
  'query',
  'refinementList',
  'page',
  'toggle',
  'range',
  'menu',
  'hitsPerPage',
  'sortBy',
  'filters',
  'configure'
] as const

export const SEO_FRIENDLY_QUERY_PARAMS: SearchStateProp[] = [
  'query',
  'refinementList',
  'page',
  'toggle',
  'range',
  'menu',
  'hitsPerPage',
  'sortBy'
]
